import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as getLocale, o as transDialog, B as classNames, m as getTheme } from './utils2.js';
import { D as DEFAULT_LANG, f as REQUEST_TIMEOUT } from './const.js';
import { d as defineCustomElement$2 } from './mapy-review-button2.js';
import { d as defineCustomElement$1 } from './mapy-review-question2.js';

const SLEEP_TIMEOUT = 1000;
const ERROR_PROPABILITY = 0;
function sleep(time) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({});
        }, time);
    });
}
function simulateError(propability) {
    return (1 - Math.random()) > (1 - propability);
}
async function getOutput(data, sleepTimeout, propability) {
    const output = {
        data,
        noError: true,
        error: "",
        status: 200,
    };
    await sleep(sleepTimeout);
    if (simulateError(propability)) {
        output.data = null;
        output.noError = false;
        output.error = "Random error";
    }
    return output;
}
function getPutReviewData(requestData) {
    const data = {
        // @ts-ignore
        review: {
            id: Math.random() * 10e6 >>> 0,
            gallery: [],
            lang: requestData.lang,
            rating: requestData.rating,
            rejectReason: "",
            review_source: requestData.review_source,
            state: "approved",
            text: requestData.text,
            type: "firm",
            updated: new Date().toISOString(),
            weight: 0,
        },
    };
    return getOutput(data, SLEEP_TIMEOUT, ERROR_PROPABILITY);
}
function getRemoveReviewData() {
    const data = {};
    return getOutput(data, SLEEP_TIMEOUT, ERROR_PROPABILITY);
}
function getMyReview({ noStructuredRating = false, }) {
    /* eslint-disable */
    const myReview = {
        "actual": true,
        "enableEdit": true,
        "gallery": [{
                "id": 15904458,
                "takeDate": "2022-08-25T13:39:27",
                "status": "approved",
                "urls": {
                    "default": "https://d34-a.sdn.test.dszn.cz/d_34/c_img_QJ_Ek/MQOCCyB.jpeg?fl=res,{width},{height},1"
                },
                "size": [
                    3072,
                    4096
                ],
                "likes": {
                    "id": "photo.foto.15904458",
                    "count": 0,
                    "rawCount": 0,
                    "voted": false
                },
                "visits": 0
            }],
        "id": 2380676997,
        "lang": "cs",
        "likes": {
            "count": 0,
            "id": "review.firm.2380676997",
            "rawCount": 0,
            "voted": false
        },
        "negatives": null,
        "positives": null,
        "rating": 90,
        "rejectReason": "",
        "reply": null,
        "review_source": "mapy-web",
        "state": "ok",
        "structured_rating": [
            {
                "key": "jidloapiti",
                "label": "Quality",
                "name": "Food and drink",
                "rating": null
            },
            {
                "key": "obsluha",
                "label": "Your satisfaction with service",
                "name": "Service",
                "rating": 100
            },
            {
                "key": "prostredi",
                "label": "Attractiveness",
                "name": "Interior",
                "rating": null
            },
            {
                "key": "cena",
                "label": "Corresponding with offered services",
                "name": "Price",
                "rating": null
            }
        ],
        "text": "aaaa",
        "topped": false,
        "type": "firm",
        "update_request": false,
        "updated": "2024-03-15T09:13:53+01:00",
        "user": {
            "bank_id": false,
            "image_url": "https://i.im.dev.dszn.cz/ac/HMbutqnWt7i5cQV-mx_qr8hTrCFIObYboLLev2w36nfkNn4hT1L6-3Lji2c",
            "name": "Testovací Kachnička II",
            "public_id": "01-16340846525982609753",
            "recovery_phone_hash": null,
            "review_count": 650,
            "verified": false
        },
        "weight": 1000
    };
    if (noStructuredRating) {
        myReview.structured_rating = [];
    }
    return myReview;
}
function getDebugQuestions(lang) {
    const isEn = lang === "en";
    const answers = [
        {
            id: "yes",
            text: isEn ? "Yes" : "Ano",
        },
        {
            id: "no",
            text: isEn ? "No" : "Ne",
        },
        {
            id: "dont_know",
            text: isEn ? "Don't know" : "Nevím",
        }
    ];
    return getOutput({
        result: [
            {
                answers,
                id: 51013,
                text: isEn ? "Is it possible to pay by card?" : "Je zde možnost platit kartou?",
                type: "technical-business-tag"
            },
            {
                answers,
                id: 51015,
                text: isEn ? "Is there a garden?" : "Mají zde zahrádku?",
                type: "technical-business-tag"
            },
            {
                answers,
                id: 31130,
                text: isEn ? "Got it food delivery?" : "Nabízí zde možnost rozvozu jídla?",
                type: "technical-business-tag"
            }
        ]
    }, SLEEP_TIMEOUT, ERROR_PROPABILITY);
}

/* eslint-disable camelcase */
const REVIEW_URL = "/reviews/v1/review";
const abortFetchSignal = (timeoutMs) => {
    if (typeof window === "undefined" || window.AbortController === undefined) {
        return undefined;
    }
    const abortController = new AbortController();
    setTimeout(() => abortController.abort(), timeoutMs);
    return abortController.signal;
};
async function fetchJSON(url, fetchOptions) {
    const output = {
        data: null,
        noError: true,
        error: "",
        status: 500,
    };
    try {
        const request = await fetch(url, Object.assign({ credentials: "include", signal: abortFetchSignal(REQUEST_TIMEOUT) }, fetchOptions));
        const jsonData = await request.json();
        output.status = request.status;
        if (request.status >= 200 && request.status < 300) {
            output.data = jsonData;
        }
        else {
            output.noError = false;
            output.error = `Wrong status ${request.status}`;
        }
    }
    catch (exc) {
        output.noError = false;
        output.error = exc.message || "";
    }
    return output;
}
function putReview(putReviewData, debug) {
    const { endpoint = "", source = "", poi_id = 0, rating = 0, review_source = "mapy-web", text = "", media_ids = [], structured_rating = [], lang = DEFAULT_LANG, market_offer_id = 0, apiKey = "", } = putReviewData;
    if (debug) {
        console.log(["putReview", {
                source,
                poi_id,
                rating,
                review_source,
                text,
                media_ids,
                structured_rating,
                market_offer_id,
            }]);
        return getPutReviewData(putReviewData);
    }
    const url = new URL(`${endpoint}${REVIEW_URL}`);
    url.searchParams.append("lang", lang);
    const data = {
        source,
        poi_id,
        rating,
        review_source,
        text,
        structured_rating,
        media_ids,
        market_offer_id,
    };
    return fetchJSON(url.toString(), {
        method: "POST",
        headers: Object.assign({ "Content-Type": "application/json" }, apiKey ? { "X-Mapy-Api-Key": apiKey } : {}),
        body: JSON.stringify(data),
    });
}
function removeReview({ endpoint = "", review_id = 0, reason, text, lang = DEFAULT_LANG, apiKey = "", }, debug) {
    if (debug) {
        console.log(["removeReview", review_id, { reason, text }]);
        return getRemoveReviewData();
    }
    const url = new URL(`${endpoint}${REVIEW_URL}/${review_id}`);
    url.searchParams.append("lang", lang);
    const data = Object.assign({}, reason && text
        ? {
            reason,
            text,
        }
        : {});
    return fetchJSON(url.toString(), {
        method: "DELETE",
        headers: Object.assign({ "Content-Type": "application/json" }, apiKey ? { "X-Mapy-Api-Key": apiKey } : {}),
        body: JSON.stringify(data),
    });
}
function getQuestions({ endpoint = "", source = "", id = 0, lang = DEFAULT_LANG, apiKey = "", }, debug = false) {
    if (debug) {
        return getDebugQuestions(lang);
    }
    const url = new URL(`${endpoint}${REVIEW_URL}/poi/${source}/${id}/questions`);
    url.searchParams.append("lang", lang);
    return fetchJSON(url.toString(), {
        method: "GET",
        headers: Object.assign({ "Content-Type": "application/json" }, apiKey ? { "X-Mapy-Api-Key": apiKey } : {}),
    });
}
function answerQuestion({ endpoint = "", source = "", id = 0, apiKey = "", answer_id = "yes", question_id = 0, question_type = "", }, debug = false) {
    if (debug) {
        console.log(["answer question", {
                endpoint,
                source,
                id,
                apiKey,
                answer_id,
                question_id,
                question_type,
            }]);
        return Promise.resolve({});
    }
    const url = new URL(`${endpoint}${REVIEW_URL}/poi/${source}/${id}/answer`);
    return fetchJSON(url.toString(), {
        method: "POST",
        headers: Object.assign({ "Content-Type": "application/json" }, apiKey ? { "X-Mapy-Api-Key": apiKey } : {}),
        body: JSON.stringify({
            question_id,
            question_type,
            answer_id,
        }),
    });
}

const mapyReviewDialogPageStickersCss = ".mapy-review-dialog-page-stickers{padding:48px 32px 48px 32px;height:100%;font-family:Arial;display:flex;box-sizing:border-box}.mapy-review-dialog-page-stickers{justify-content:center;align-items:center}.set-questions{display:flex;flex:1;justify-content:space-between;flex-direction:column;gap:24px;height:100%}.onboarding{display:flex;flex-direction:column;gap:8px;align-items:center}.question-title{margin:0;text-align:center;color:#000;font-size:15px;font-style:normal;font-weight:400;line-height:140%;}.prev-question{display:flex;flex-direction:column;gap:0}.prev-question-title{margin:0;color:#6E6E6E;text-align:center;font-size:12px;font-style:normal;font-weight:400;line-height:16px;}.prev-question-text{margin:0;color:#000;text-align:center;font-size:15px;font-style:normal;font-weight:400;line-height:140%;}.prev-question-answer{margin:0;color:#C00;text-align:center;font-size:15px;font-style:normal;font-weight:400;line-height:140%;}.thank-you{display:flex;flex-direction:column;gap:24px;align-items:center;position:relative;top:-24px}.thank-you-title{color:#000;margin:0;text-align:center;font-size:18px;font-style:normal;font-weight:700;line-height:140%;}";
const MapyReviewDialogPageStickersStyle0 = mapyReviewDialogPageStickersCss;

var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MapyReviewDialogPageStickers_lang;
const MapyReviewDialogPageStickers = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageStickers extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.afterQuestions = createEvent(this, "afterQuestions", 1);
        _MapyReviewDialogPageStickers_lang.set(this, "");
        this.onAnswer = (event) => {
            const curQuestion = this.questions[this.questPos - 1];
            const response = {
                question_id: curQuestion.id,
                question_type: curQuestion.type,
                answer_id: event.detail,
            };
            this.answers.push(response);
            this.signal.emit({
                name: "answer-select",
                id: curQuestion.id,
                type: curQuestion.type,
                answerId: event.detail,
            });
            // posleme dotaz na BE
            answerQuestion(Object.assign({ source: this.poiSource, id: this.poiId, apiKey: this.apiKey, endpoint: this.endpoint }, response), this.debug);
            this.questPos++;
            this.isDone = this.questPos > this.questCount;
            if (this.isDone) {
                this.signal.emit({
                    name: "answer-select-done",
                });
                this.afterQuestions.emit({});
            }
        };
        this.endpoint = "";
        this.apiKey = "";
        this.service = "mapy";
        this.poiSource = "";
        this.poiId = 0;
        this.debug = false;
        this.questions = [];
        this.questPos = 1;
        this.questCount = 1;
        this.answers = [];
        this.isDone = false;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewDialogPageStickers_lang, getLocale(this.hostElement), "f");
        this.questPos = 1;
        this.questCount = this.questions.length;
    }
    answerToText(answer) {
        switch (answer) {
            case "yes":
                return transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "responseYes");
            case "dont_know":
                return transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "responseDontKnow");
            case "no":
                return transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "responseNo");
        }
        return "";
    }
    render() {
        const theme = getTheme(this.service);
        const curQuestion = this.questions[this.questPos - 1];
        const prevQuestion = this.questPos > 1
            ? this.questions[this.questPos - 2]
            : null;
        const prevAnswer = this.answers.length ?
            this.answers[this.answers.length - 1]
            : null;
        return (h(Host, { key: 'c29d2b0aaf183b51580652f944a88952219629e9' }, h("div", { key: '5a7f618679ad5b8583da461354bdbcc3efc8eb61', class: classNames(["mapy-review-dialog-page-stickers", this.isDone ? "is-done" : ""]), "data-theme": theme }, this.isDone && h("div", { key: 'bd667ed3ae827b4d6a375a3384dcfab4af4f3e5a', class: "thank-you" }, h("svg", { key: 'c75266ffc39e8c140732551b15d3e8689d69f6e1', xmlns: "http://www.w3.org/2000/svg", width: "73", height: "72", viewBox: "0 0 73 72", fill: "none" }, h("mask", { key: '88df39f0be7b93193690518464180003d7bdd117', id: "mask0_8303_95448", style: { maskType: "alpha" }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "73", height: "72" }, h("rect", { key: '14103c13d643a027c03a5c9906bc682777c2ef2a', x: "0.5", width: "72", height: "72", fill: "#D9D9D9" })), h("g", { key: '9acfc5e290014595d2d811cc999af52eee75311a', mask: "url(#mask0_8303_95448)" }, h("path", { key: 'f64d4f4a241438ea8b31c00217ff800e1f65e575', d: "M28.8498 47.1012L56.0748 19.8762C56.5383 19.4262 57.0793 19.2012 57.6978 19.2012C58.3158 19.2012 58.8498 19.4274 59.2998 19.8799C59.7498 20.3329 59.9748 20.8704 59.9748 21.4924C59.9748 22.1149 59.7498 22.6512 59.2998 23.1012L30.4248 51.9762C29.9748 52.4262 29.4498 52.6512 28.8498 52.6512C28.2498 52.6512 27.7248 52.4262 27.2748 51.9762L13.6248 38.3262C13.1748 37.8727 12.9623 37.3344 12.9873 36.7114C13.0123 36.0879 13.2511 35.5512 13.7036 35.1012C14.1566 34.6512 14.6941 34.4262 15.3161 34.4262C15.9386 34.4262 16.4748 34.6512 16.9248 35.1012L28.8498 47.1012Z", fill: "#1EAE00" }))), h("h3", { key: '8083e9d270410725983d65696c2c4883f0b6c054', class: "thank-you-title" }, transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "questionsThankYou"), " \u2764\uFE0F")), !this.isDone && h("div", { key: 'a7ab45d7db4e02ebe9a8a0ada2f838ad062b3c75', class: "set-questions" }, this.questPos === 1 && h("div", { key: '3c9c6e247c4bf1ddfdf383429054137470676ccb', class: "onboarding" }, h("svg", { key: '9e50f5bc4cdcd5b346aad5c7689d9ff9562b779e', width: "41", height: "40", viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("mask", { key: 'e80033f00d5cd834292fce769e75fd7eeef3ee10', id: "mask0_8303_112693", style: { maskType: "alpha" }, maskUnits: "userSpaceOnUse", x: "0", y: "-1", width: "41", height: "41" }, h("rect", { key: '2b761a3cf2415fe00ddddafda7661d28621bf537', x: "0.5", y: "-0.00585938", width: "40", height: "40", fill: "#D9D9D9" })), h("g", { key: 'e14b97df3f6e436e7a214f9663d8cb953cffcef8', mask: "url(#mask0_8303_112693)" }, h("path", { key: '3138e3f5d381c931afbcf2e09794eb328fe74d7e', d: "M16.3054 25.8548L31.0971 11.0632C31.3802 10.7854 31.7102 10.6465 32.0871 10.6465C32.4643 10.6465 32.7918 10.7858 33.0696 11.0644C33.3474 11.3433 33.4863 11.6743 33.4863 12.0573C33.4863 12.4407 33.3474 12.7712 33.0696 13.049L17.2779 28.8548C17.0002 29.1326 16.676 29.2715 16.3054 29.2715C15.9352 29.2715 15.6111 29.1326 15.3334 28.8548L7.88877 21.4102C7.61099 21.1313 7.47905 20.8 7.49294 20.4161C7.50682 20.0325 7.65321 19.7018 7.9321 19.424C8.21071 19.1462 8.54169 19.0073 8.92502 19.0073C9.30835 19.0073 9.63891 19.1462 9.91669 19.424L16.3054 25.8548Z", fill: "#1EAE00" }))), h("p", { key: '629465b7c2c1aa4ef20a7ba8e8ae3a6bc0635ccc', class: "question-title", innerHTML: transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "questionsTitle", { br: "<br/>" }) })), this.questPos > 1 && h("div", { key: 'b73cf71880072d9e80cc2aead02d3ddb1faea591', class: "prev-question" }, h("p", { key: '4c0fae308a32cbf674ed3dae24bc5b2f84b47870', class: "prev-question-title" }, transDialog(__classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f"), "questionsPrev")), h("p", { key: '8029aaf95cf96d65cbdb2edee3d8e357513913e9', class: "prev-question-text" }, prevQuestion ? prevQuestion.text : ""), h("p", { key: '92bcc80b3d501602c0ee78adc159743004f0c4db', class: "prev-question-answer" }, prevAnswer ? this.answerToText(prevAnswer.answer_id) : "")), h("mapy-review-question", { key: 'b4fb2a323e1f76034fb4be0fc8242db854a69338', service: this.service, question: curQuestion.text, questPos: this.questPos, questCount: this.questCount, onAnswer: this.onAnswer, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStickers_lang, "f") })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogPageStickersStyle0; }
}, [1, "mapy-review-dialog-page-stickers", {
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "service": [513],
        "poiSource": [513, "poi-source"],
        "poiId": [514, "poi-id"],
        "debug": [516],
        "questions": [16],
        "questPos": [32],
        "questCount": [32],
        "answers": [32],
        "isDone": [32]
    }]);
_MapyReviewDialogPageStickers_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-stickers", "mapy-review-button", "mapy-review-question"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-stickers":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageStickers);
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "mapy-review-question":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageStickers as M, getQuestions as a, defineCustomElement as d, getMyReview as g, putReview as p, removeReview as r };

//# sourceMappingURL=mapy-review-dialog-page-stickers2.js.map